const TransactionActionEnum = Object.freeze({
    CHANGE_AMOUNTS_AND_SHARES: 'CHANGE_AMOUNTS_AND_SHARES',
    CHANGE_PRODUCT: 'CHANGE_PRODUCT',
    CHANGE_SALE_AMOUNT: 'CHANGE_SALE_AMOUNT',
    CHANGE_FUND_AMOUNT: 'CHANGE_FUND_AMOUNT',
    TOGGLE_ON_OFF_PLATFORM: 'TOGGLE_ON_OFF_PLATFORM',
    DELETE_TRANSACTION: 'DELETE_TRANSACTION'
});

export default TransactionActionEnum;
